/**
 *レスポンシブチェック
 *cssのwidth=2でSP以下を判断
 **/
export var resizecheck;
export function resizeFunc() {
		resizecheck = $('#responsibleCheck').width();
}